import { render } from "./JournalPage.vue?vue&type=template&id=3e33d9ff&scoped=true"
import script from "./JournalPage.vue?vue&type=script&lang=js"
export * from "./JournalPage.vue?vue&type=script&lang=js"

import "./JournalPage.vue?vue&type=style&index=0&id=3e33d9ff&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e33d9ff"]])

export default __exports__